var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 5.35156C6.25 2.93656 8.21 0.976562 10.625 0.976562C13.04 0.976562 15 2.93656 15 5.35156C15 7.76656 13.04 9.72656 10.625 9.72656H10.625C10.345 9.72656 10.065 9.72656 9.8025 9.67406L9.75 9.72656V11.4766H6.25V14.9766H1V11.4766L6.3025 6.17406C6.25 5.91156 6.25 5.63156 6.25 5.35156ZM12.0134 4.92525C12.5871 4.92525 13.0522 4.46016 13.0522 3.88645C13.0522 3.31274 12.5871 2.84766 12.0134 2.84766C11.4397 2.84766 10.9746 3.31274 10.9746 3.88645C10.9746 4.46016 11.4397 4.92525 12.0134 4.92525Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKey);
export default __webpack_public_path__ + "static/media/icon-key.0610bed11c8bfba7c4017d736b49e561.svg";
export { ForwardRef as ReactComponent };